import codesearch from './codesearch/index.json';
import rights from './rights/index.json';
import ucloud from './ucloud/index.json';
import shop from './shop/index.json';
import booksearch from './booksearch/index.json';
import dxactivity from './dxactivity/index.json';
import init from './init/index.json';
import capi from './capi/index.json';
import dxtools from './dxtools/index.json';
import bookDetails from './bookdetails/index.json';
import dxkits from './kits/index.json';
import wakeup from './wakeup/index.json';
import { envIdentifier } from '@/utils/env';

const domain = (() => {
  const isProd = process.env.NODE_ENV === 'production';
  return isProd ? location.origin : `${location.origin}/api`;
})();
export const wakeupDomain = (() => {
  const isProd = window.location.host.includes('daxuesoutijiang.com');
  return isProd ? 'https://api.wakeup.fun' : `https://api-${envIdentifier}-wuf.suanshubang.com`;
})();

function apiFormat(
  basePath: string,
  apiList: { [index: string]: { [index: string]: string } }
): { [key: string]: unknown } {
  if (Object.keys(apiList).length) {
    Object.keys(apiList).forEach(key => {
      Object.keys(apiList[key]).forEach(iKey => {
        const curApi = apiList[key][iKey];
        apiList[key][iKey] = `${domain}/${basePath}${curApi}`;
      });
    });
  }
  return apiList;
}

export const api = {
  ...apiFormat('codesearch', codesearch),
  ...apiFormat('capi', capi),
  ...apiFormat('rights', rights),
  ...apiFormat('ucloud', ucloud),
  ...apiFormat('shop', shop),
  ...apiFormat('booksearch', booksearch),
  ...apiFormat('dxactivity', dxactivity),
  ...apiFormat('init', init),
  ...apiFormat('dxtools', dxtools),
  ...apiFormat('dxapp', bookDetails),
  ...apiFormat('dxkits', dxkits),
  ...apiFormat('wakeup', wakeup) // 为 wakeup 模块使用特殊的域名
};
